import { Controller } from "@hotwired/stimulus"
import { Dropzone } from "dropzone"

export default class extends Controller {
  static targets = ["submitButton", "hiddenInput"]
  
  connect() {
    console.log("🚀 DROPZONE CONTROLLER CONNECTED! 🚀")
    console.log("Element:", this.element)
    
    // Disable Dropzone autodiscover to avoid conflicts
    Dropzone.autoDiscover = false
    
    this.setupDropzone()
  }
  
  disconnect() {
    if (this.dropzone) {
      this.dropzone.destroy()
    }
  }
  
  setupDropzone() {
    // Create a table container for file previews
    this.previewContainer = document.createElement('div')
    this.previewContainer.className = 'mt-4 hidden'
    this.previewContainer.innerHTML = `
      <div class="overflow-hidden rounded-md border border-gray-200">
        <table class="min-w-full divide-y divide-gray-200">
          <thead class="bg-gray-50">
            <tr>
              <th scope="col" class="px-3 py-2 text-left text-[10px] font-medium text-gray-500">Nome</th>
              <th scope="col" class="px-3 py-2 text-left text-[10px] font-medium text-gray-500">Tamanho</th>
              <th scope="col" class="px-3 py-2 text-right text-[10px] font-medium text-gray-500">Ações</th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200" id="file-previews-tbody">
          </tbody>
        </table>
      </div>
    `
    this.element.parentNode.insertBefore(this.previewContainer, this.element.nextSibling)
    this.tableBody = this.previewContainer.querySelector('#file-previews-tbody')
    
    // Configure Dropzone with minimal options
    try {
      this.dropzone = new Dropzone(this.element, {
        url: "/dummy", // Required but we'll override
        autoProcessQueue: false,
        uploadMultiple: true,
        maxFilesize: 10,
        acceptedFiles: ".pdf,.doc,.docx,.xls,.xlsx,.txt,.jpeg,.jpg,.png,.gif,.zip,.rar",
        addRemoveLinks: false,
        createImageThumbnails: false,
        previewsContainer: this.tableBody,
        previewTemplate: `
          <tr class="dz-preview hover:bg-gray-50">
            <td class="px-3 py-2 text-[10px] font-medium text-gray-900">
              <div class="flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-3 h-3 mr-1.5 text-blue-500">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                </svg>
                <span class="truncate dz-name" data-dz-name></span>
              </div>
            </td>
            <td class="px-3 py-2 text-[9px] text-gray-500">
              <span class="bg-gray-100 px-1 py-0.5 rounded-full dz-size" data-dz-size></span>
            </td>
            <td class="px-3 py-2 text-right">
              <button type="button" class="dz-remove bg-white rounded-full p-1 shadow-sm hover:bg-red-50 transition-colors" title="Remover">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-3 h-3 text-red-600">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                </svg>
              </button>
            </td>
          </tr>
        `,
        init: function() {
          console.log("Dropzone initialized successfully!")
        }
      })
      
      // Add event handlers
      this.dropzone.on("addedfile", (file) => {
        console.log("File added:", file.name)
        this.updateSubmitButton()
        this.updateTableVisibility()
      })
      
      this.dropzone.on("removedfile", (file) => {
        console.log("File removed:", file.name)
        this.updateSubmitButton()
        this.updateTableVisibility()
      })
      
      // Handle form submission
      this.element.closest('form').addEventListener('submit', (e) => {
        e.preventDefault()
        
        if (this.dropzone.files.length > 0) {
          const formData = new FormData(this.element.closest('form'))
          formData.delete('files')
          
          this.dropzone.files.forEach(file => {
            formData.append('files[]', file)
          })
          
          fetch(this.element.closest('form').action, {
            method: 'POST',
            body: formData,
            headers: {
              'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
            }
          }).then(response => {
            if (response.ok) {
              window.location.reload()
            }
          })
        }
      })
      
    } catch (error) {
      console.error("Error setting up Dropzone:", error)
    }
  }
  
  updateSubmitButton() {
    if (this.hasSubmitButtonTarget) {
      if (this.dropzone.files.length > 0) {
        this.submitButtonTarget.classList.remove('hidden')
      } else {
        this.submitButtonTarget.classList.add('hidden')
      }
    }
  }
  
  updateTableVisibility() {
    if (this.dropzone.files.length > 0) {
      this.previewContainer.classList.remove('hidden')
    } else {
      this.previewContainer.classList.add('hidden')
    }
  }
}